import { render } from "./lefttree.vue?vue&type=template&id=1806e9a4&scoped=true&ts=true"
import script from "./lefttree.vue?vue&type=script&lang=ts"
export * from "./lefttree.vue?vue&type=script&lang=ts"

import "./lefttree.vue?vue&type=style&index=0&id=1806e9a4&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1806e9a4"]])

export default __exports__